import { sileo } from 'sileo';

type ConfirmType = 'warning' | 'info';

interface ConfirmOptions {
    title: string;
    description?: string;
    confirmText?: string;
    cancelText?: string;
    type?: ConfirmType;
}

// 2026-08-26: el botón de confirmar de `sileo` (el toast animado de abajo)
// no dispara su `onClick` de forma confiable — se reprodujo con un click
// real de usuario, no era solo un artefacto de test automatizado. Hasta
// que se entienda la causa (o se actualice/reemplace `sileo`), se usa el
// diálogo nativo del navegador acá: menos vistoso, pero confirma siempre.
// Esto arregla de una vez todos los `confirmToast`/`toast.confirm` del
// proyecto (Kanban, Clientes, Documentos, Audios, Ventas, etc.) sin tener
// que tocar cada lugar que lo llama — la firma (`Promise<boolean>`) no cambia.
export const confirmToast = (opts: ConfirmOptions): Promise<boolean> => {
    const mensaje = opts.description ? `${opts.title}\n\n${opts.description}` : opts.title;
    return Promise.resolve(window.confirm(mensaje));
};

export const toast = {
    success: (msg: string, description?: string) => sileo.success({ title: msg, description }),
    error: (msg: string, description?: string) => sileo.error({ title: msg, description }),
    warning: (msg: string, description?: string) => sileo.warning({ title: msg, description }),
    info: (msg: string, description?: string) => sileo.info({ title: msg, description }),
    confirm: confirmToast,
    promise: sileo.promise,
    dismiss: sileo.dismiss
};